import { createFileRoute, Link } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
})

function UnauthorizedPage() {
  return (
    <div className='flex min-h-screen items-center justify-center px-4'>
      <div className='max-w-md text-center'>
        <ShieldAlert className='text-destructive mx-auto h-24 w-24' />
        <h1 className='mt-6 text-3xl font-bold tracking-tight'>
          Access Denied
        </h1>
        <p className='text-muted-foreground mt-4'>
          You don't have permission to access this resource. If you believe this
          is an error, please contact your administrator.
        </p>
        <div className='mt-8 flex justify-center gap-4'>
          <Button asChild variant='outline'>
            <Link to='/'>Go to Dashboard</Link>
          </Button>
          <Button asChild>
            <Link to='/profile'>My Profile</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
